export default __webpack_public_path__ + "static/media/rabbit_type_4_2.2f76dc4f.svg";